import clsx from 'clsx'

export const confirmButtonClassName =
  'w-full rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50'

export const tabClassName = (isActive: boolean) =>
  clsx('rounded px-3 py-1.5 text-sm font-medium transition-colors', isActive ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900')
